import React from 'react';

import SelectorChip from 'components/DesignSystem/SelectorChip';
import { ALL_KINDS, FOLDER_KIND, KindCount } from 'helper/products/fileExplorer';

import './index.scss';

const kindLabel = (kind: string) => {
  if (kind === ALL_KINDS) return 'Todos';
  if (kind === FOLDER_KIND) return 'Pastas';
  return kind ? kind.toUpperCase() : 'Sem extensão';
};

export default function TypeFilters({
  kinds,
  active,
  onSelect,
}: {
  kinds: KindCount[];
  active: string;
  onSelect: (kind: string) => void;
}) {
  // Só "Todos" (pasta vazia / nada encontrado): os chips não filtrariam nada.
  if (kinds.length <= 1) return null;

  return (
    <div className="file-explorer-type-filters" role="group" aria-label="Filtrar por tipo">
      {kinds.map(({ kind, count }) => (
        <SelectorChip
          key={kind}
          shape="round"
          selected={kind === active}
          onClick={() => onSelect(kind)}
          className="file-explorer-type-chip"
        >
          <span>{kindLabel(kind)}</span>
          <span className="file-explorer-type-count">{count.toLocaleString('pt-BR')}</span>
        </SelectorChip>
      ))}
    </div>
  );
}
